import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HASH_SCROLL_MAX_ATTEMPTS = 40;
const HASH_SCROLL_RETRY_MS = 75;

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    const targetId = decodeURIComponent(hash.replace(/^#/, ""));
    let attempts = 0;
    let timerId: number | null = null;
    let rafId: number | null = null;

    const scrollToHashTarget = () => {
      const target = document.getElementById(targetId);

      if (target) {
        const prefersReducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

        target.scrollIntoView({
          behavior: prefersReducedMotion ? "auto" : "smooth",
          block: "start",
        });
        return;
      }

      attempts += 1;

      if (attempts < HASH_SCROLL_MAX_ATTEMPTS) {
        timerId = window.setTimeout(scrollToHashTarget, HASH_SCROLL_RETRY_MS);
      }
    };

    rafId = window.requestAnimationFrame(() => {
      scrollToHashTarget();
    });

    return () => {
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }

      if (timerId !== null) {
        window.clearTimeout(timerId);
      }
    };
  }, [location.pathname, location.hash]);

  return null;
};

export default ScrollToTop;
